import React from 'react';

import { useLanguage } from '../i18n';

const Faq = () => {
  const { faq, faqSection } = useLanguage().t;

  return (
    <section id='help' className='pb-20 lg:pb-28'>
      <div className='container grid gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16'>
        <div>
          <p className='eyebrow'>{faqSection.eyebrow}</p>
          <h2 className='title mt-4 max-w-[360px]'>{faqSection.title}</h2>
          <p className='lead mt-5 max-w-[380px]'>{faqSection.text}</p>
        </div>

        <div className='divide-y divide-line border-y border-line'>
          {faq.map((item, index) => (
            <details key={index} className='faq py-1'>
              <summary className='flex min-h-[64px] cursor-pointer list-none items-center justify-between gap-6 py-4 text-lg font-semibold'>
                {item.question}
                <span
                  className='faq-icon relative h-8 w-8 shrink-0 rounded-full bg-ronda-soft'
                  aria-hidden='true'
                />
              </summary>
              <p className='max-w-[620px] pb-6 pr-12 leading-relaxed text-muted'>
                {item.answer}
              </p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;
